/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  // CREATE_INSTRUCTIONS,
  // UPDATE_INSTRUCTIONS,
  // DELETE_INSTRUCTIONS,
  UPDATE_EQUIPMENT_SCHEDULING,
  ADD_EQUIPMENT_SCHEDULING,
  LOAD_EQUIPMENT_SCHEDULING,
  LOAD_RECORDS_META_DATA,
  EQUIPMENT_VACANCY_LIST,
  EQUIPMENT_OFFICE_VACANCY_LIST,
  EQUIPMENT_FINAL_COMMIT,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  // createInstructionSuccess,
  // createInstructionError,
  // updateInstructionSuccess,
  // updateInstructionError,
  // deleteInstructionSuccess,
  // deleteInstructionError,
  loadEquipmentScheduling,
  loadEquipmentSchedulingSuccess,
  loadEquipmentSchedulingError,
  addEquipmentDetailsSuccess,
  addEquipmentDetailsError,
  updateEquipmentDetailsSuccess,
  updateEquipmentDetailsError,
  loadEquipmentVacancy,
  loadEquipmentVacancySuccess,
  loadEquipmentVacancyError,
  loadEquipmentOfficeVacancy,
  loadEquipmentOfficeVacancySuccess,
  loadEquipmentOfficeVacancyError,
  equipmentFinalCommitSuccess,
  equipmentFinalCommitError,
} from "./actions"

import {
  loadRecordsMetaData,

  // createInstruction,
  // updateInstruction,
  // deleteInstruction,
  loadEquipmentSchedulingDetails,
  addEquipmentSchedule,
  updateEquipmentSchedule,
  loadEquipmentVacancyDetails,
  loadEquipmentOfficeVacancyDetails,
  equipmentFinalCommitDetails,
} from "./remotes"

//Special Instructions
function* loadEquipmentSchedulingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EQUIPMENT_SCHEDULING),
    })

    const { explicitLoad } = load

    const { record } = explicitLoad || {}
    yield put(loadEquipmentScheduling(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEquipmentSchedulingDetails, record)

        if (result) {
          yield put(loadEquipmentSchedulingSuccess(result.data))
        } else {
          yield put(loadEquipmentSchedulingError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEquipmentSchedulingError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addEquipmentDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_EQUIPMENT_SCHEDULING),
    })
    const { equipmentDetails } = create || {}

    if (create) {
      console.log("records", equipmentDetails)
      try {
        yield call(addEquipmentSchedule, equipmentDetails)

        var successVal = addEquipmentDetailsSuccess(
          equipmentDetails,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          addEquipmentDetailsError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* updateTeamScheduleSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_EQUIPMENT_SCHEDULING),
    })

    console.log("FFFF &&& Lokesh Func ->", edit)

    const { equipmentDetails } = edit || {}
    if (edit) {
      try {
        yield call(updateEquipmentSchedule, equipmentDetails)
        // yield delay(1000)
        yield put(
          updateEquipmentDetailsSuccess(
            equipmentDetails,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateEquipmentDetailsError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}


function* loadEquipmentVacancyDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(EQUIPMENT_VACANCY_LIST),
    })

    const { explicitLoad } = load

    const { record } = explicitLoad || {}
    yield put(loadEquipmentVacancy(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEquipmentVacancyDetails, record)

        if (result) {
          yield put(loadEquipmentVacancySuccess(result.data))
        } else {
          yield put(loadEquipmentVacancyError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEquipmentVacancyError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadEquipmentOfficeVacancyDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(EQUIPMENT_OFFICE_VACANCY_LIST),
    })

    const { explicitLoad } = load

    const { record } = explicitLoad || {}
    yield put(loadEquipmentOfficeVacancy(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEquipmentOfficeVacancyDetails, record)

        if (result) {
          yield put(loadEquipmentOfficeVacancySuccess(result.data))
        } else {
          yield put(loadEquipmentOfficeVacancyError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEquipmentOfficeVacancyError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}


function* equipmentFinalCommitDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(EQUIPMENT_FINAL_COMMIT),
    })
    const { equipmentCommit } = create || {}

    if (create) {
      console.log("records", equipmentCommit)
      try {
        yield call(equipmentFinalCommitDetails, equipmentCommit)

        var successVal = equipmentFinalCommitSuccess(
          equipmentCommit,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          equipmentFinalCommitError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const branch = yield call(loadRecordsMetaData, "branch", "post")
      const vendor = yield call(loadRecordsMetaData, "vendor", "post")
      // const equipmentMaster = yield call(
      //   loadRecordsMetaData,
      //   "equipment_master",
      //   "post"
      // )
      let recordsMetaData = {
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: `${c.companyCode} - ${c.name}`,
                    value: c._id,
                    companyId: c.companyId,
                    companyCode: c.companyCode,
                  }
                )
              )) ||
          [],
        vendorOptions:
          (vendor &&
            vendor.data &&
            vendor.data.length > 0 &&
            vendor.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    value: c._id,
                    label: `${c.vendorCode} - ${c.vendorName}`,
                    vendorCode: c.vendorCode ,
                    vendorName: c.vendorName,
                    vendorType: c.vendorType,
                    paymentDetails: c.paymentDetails
                  }
                )
              )) ||
          [],
        // equipmentMasterOptions:
        //   (equipmentMaster &&
        //     equipmentMaster.data &&
        //     equipmentMaster.data.length > 0 &&
        //     equipmentMaster.data
        //       .filter((_) => _.status === 1)
        //       .map((c) =>
        //         Object.assign(
        //           {},
        //           {
        //             label: `${c.serialNumber} - ${c.productVersionName}`,
        //             value: c._id,
        //             equipmentTypeName: c.equipmentTypeName,
        //             equipmentBrandName: c.equipmentBrandName,
        //             productVersionName: c.productVersionName,
        //             equipmentTypeId: c.equipmentTypeId,
        //             // companyId: c.companyId,
        //           }
        //         )
        //       )) ||
        //   (equipmentMaster &&
        //     equipmentMaster.length > 0 &&
        //     equipmentMaster.map((c) =>
        //       Object.assign(
        //         {},
        //         {
        //           label: `${c.serialNumber} - ${c.productVersionName}`,
        //           value: c._id,
        //           equipmentTypeName: c.equipmentTypeName,
        //           equipmentBrandName: c.equipmentBrandName,
        //           productVersionName: c.productVersionName,
        //           equipmentTypeId: c.equipmentTypeId,
        //           // companyId: c.companyId,
        //         }
        //       )
        //     )) ||
        //   [],
      }

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    addEquipmentDetailsSaga(),
    updateTeamScheduleSaga(),
    loadEquipmentSchedulingSaga(),
    loadEquipmentOfficeVacancyDetailsSaga(),
    loadEquipmentVacancyDetailsSaga(),
    equipmentFinalCommitDetailsSaga()
  ])
}
